import { render, staticRenderFns } from "./kolam_renang.vue?vue&type=template&id=cb12dc4a&"
import script from "./kolam_renang.vue?vue&type=script&lang=js&"
export * from "./kolam_renang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports